import { FC } from 'react'
import { Button } from '@/atoms/Button'
import { useThemeContext } from '@/contexts/ThemeContext'
import { Offer } from '@/services/PifService'
import { usePifOfferTickets } from '@/views/ExpressCheckoutView/components/useOfferTickets'

interface Props {
  offer: Offer
  isSelected: boolean
  onClick: () => void
  disabled?: boolean
}
export const ExpressOffer: FC<Props> = ({ offer, isSelected, onClick, disabled }) => {
  const { formattedNumberOfTickets } = usePifOfferTickets({ offer })
  const { isDarkMode } = useThemeContext()
  const unselectedVariant = isDarkMode ? 'core-gray-800' : 'gray'
  const selectedVariant = isDarkMode ? 'white' : 'black'

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className="!h-12 !w-full !min-w-[4.5rem] !max-w-[5.5rem] rounded-[50px]"
      variant={isSelected ? selectedVariant : unselectedVariant}
    >
      {formattedNumberOfTickets}
    </Button>
  )
}
